export const COUNTRY__IT = 'it';
export const COUNTRY__US = 'us';
export const COUNTRY__ES = 'es';
export const COUNTRY__ES_CA = 'es_ca';
